import { gql } from '@apollo/client'

export type GatewaySubgraphComposeStatus =
  | 'INCLUDED'
  | 'EXCLUDED'
  | 'UNREACHABLE'

export type GatewaySubgraphStatus = {
  name: string
  url: string
  status: GatewaySubgraphComposeStatus
  lastComposedAt?: string | null
  error?: string | null
}

export type GatewaySupergraphStatus = {
  lastReloadAt?: string | null
  degraded: boolean
  subgraphs: GatewaySubgraphStatus[]
}

export const gatewaySupergraphStatusQuery = gql`
  query GatewaySupergraphStatus {
    gatewaySupergraphStatus {
      lastReloadAt
      degraded
      subgraphs {
        name
        url
        status
        lastComposedAt
        error
      }
    }
  }
`
